import { useEffect, useState } from 'react'
import moment from 'moment'

import { getFactDutyFilter } from '@pages/BarDiagramPage/helpers/getFactDutyFilter'

import { INCREMENT_TYPE } from '@constants'
import { AutocompleteOption } from '@types'

import { SelectedBar } from '../../../types/api/barChart.api'

type UseViewFilterParams = {
  selectedBar?: SelectedBar
  watchFromDate: string
  watchDepartment: AutocompleteOption<string> | null
  watchQual: AutocompleteOption<string> | null
  watchPosition: AutocompleteOption<string> | null
  watchGroup: AutocompleteOption<string> | null
}

export const useViewFilter = ({
  selectedBar,
  watchFromDate,
  watchDepartment,
  watchQual,
  watchPosition,
  watchGroup,
}: UseViewFilterParams) => {
  const [viewFilter, setViewFilter] = useState<
    { from: string; to: string; filter: string; entityId?: number } | undefined
  >(undefined)

  useEffect(() => {
    if (selectedBar?.resource?.viewId) {
      const dateRange = selectedBar.series.dateRange
      setViewFilter(prevState => {
        const newRange = { from: addToDate(dateRange.from), to: addToDate(dateRange.till) }
        const filter = getFactDutyFilter(
          newRange.from,
          newRange.to,
          watchDepartment,
          watchQual,
          watchPosition,
          watchGroup,
          selectedBar?.column,
          watchFromDate
        )

        return { ...newRange, filter, entityId: selectedBar.resource?.viewId }
      })
    }
  }, [selectedBar])

  // const resetToDayFilter = () => {
  //   if (!viewRef.current) {
  //     return
  //   }
  //
  //   viewRef.current.refreshObjectData({ filter: getAllPlanDayFilter(watchFromDate) })
  // }

  const addToDate = (value: string) => {
    let unit: moment.unitOfTime.DurationConstructor
    switch (selectedBar?.timeIncrement) {
      default:
      case INCREMENT_TYPE.HOUR:
        unit = 'hours'
        break
      case INCREMENT_TYPE.MINUTE:
        unit = 'minutes'
        break
      case INCREMENT_TYPE.DAY:
        unit = 'days'
        break
      case INCREMENT_TYPE.WEEK:
        unit = 'weeks'
        break
      case INCREMENT_TYPE.MONTH:
        unit = 'months'
        break
    }

    return moment(watchFromDate).add(value, unit).toISOString()
  }

  return { viewFilter, setViewFilter }
}
